import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';

import ContactModal from '../ContactModal';
import { colors } from '../../styles';
import icons from '../IconsList';

const styles = css`
  width: 100%;
  height: 67px;
  background-color: ${colors.text};
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  .MobileOSC_list {
    display: flex;
    height: 100%;
    margin: 0;
    background-color: #252525;
    li {
      flex: 1;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding: 0 0 10px;
    }
  }
  .MobileOSC_title {
    font-weight: 700;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 23px;
    padding: 0 15px;
    margin: 0;
    @media(min-width: 350px) {
      padding: 0 15px;
    }
  }
  .MobileOSC_wrapper {
    height: 100%;
    align-items: center;
    max-width: 420px;
  }
  .MobileOSC_linksItem, .ContactModal_btn {
    font-weight: 800;
    font-size: 11px;
    color: ${colors.color1};
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  .ContactModal_btn {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    &:focus {
      outline: none;
    }
  }
`;

function FooterMobileOSC({ builder, agent }) {
  const phoneNumber = get(agent, 'telephone') || get(builder, 'telephone');
  return (
    <div className={styles}>
      <div className="col-sm-8 d-flex MobileOSC_wrapper px-0">
        <h5 className="MobileOSC_title">Talk Now!</h5>
        <ul className="MobileOSC_list list-unstyled flex-fill">
          <li>
            <a href={`tel:${phoneNumber.replace(/[^0-9]/g, '')}`} className="MobileOSC_linksItem d-flex flex-column mt-2">
              <img src={get(icons, 'mobile-call')} alt="phone icon" className="mb-1" />Call
            </a>
          </li>
          <li>
            <ContactModal builder={builder}>
              <img src={get(icons, 'mobile-email')} alt="email icon" className="mb-2" />Email
            </ContactModal>
          </li>
          <li>
            <a href={`sms:${phoneNumber.replace(/[^0-9]/g, '')}`} className="MobileOSC_linksItem d-flex flex-column mt-2">
              <img src={get(icons, 'mobile-text')} alt="text icon" className="mb-1" />Text
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

FooterMobileOSC.propTypes = {
  builder: PropTypes.object.isRequired,
  agent: PropTypes.object.isRequired,
};

export default withData(
  {
    community: true,
    agent: true,
  },
  {
    required: {
      agent: true,
    },
  },
)(FooterMobileOSC);



// WEBPACK FOOTER //
// ./src/components/PageWrapper/OSCTagMobile.js